/**
 * Group-appointment merge for CONTINUOUS (Dauertermin) appointments, shared by
 * the legacy mixed CalendarController and the MobiliCalendar continuous
 * controller. Pure — extracted so the two controllers cannot drift.
 *
 * For continuous KGG the API delivers group data twice: the therapist-side
 * appointment (type ContinuousGroupTimeSlotTherapist) already CONTAINS its
 * participants, and each participant additionally appears as a standalone
 * patient-side appointment (ContinuousGroupTimeSlotPatient). Rendering both
 * would duplicate every participant, so the standalone patient-side rows whose
 * group host is present are dropped.
 */
import { ContinuousAppointmentDto } from "../../../../api-client";

export const mergeGroupPatientIntoContinuousTherapistAppointments = (
  appointments: ContinuousAppointmentDto[],
): ContinuousAppointmentDto[] => {
  const therapistIds = new Set<string>();

  for (const appointment of appointments) {
    const therapistSlot = appointment.timeSlots?.find(
      (ts) => ts.type === "ContinuousGroupTimeSlotTherapist",
    );
    if (therapistSlot) {
      therapistIds.add(appointment.id!);
    }
  }

  return appointments.filter(
    (app) =>
      !app.timeSlots?.every(
        (ts) =>
          ts.type === "ContinuousGroupTimeSlotPatient" &&
          ts.groupAppointmentId &&
          therapistIds.has(ts.groupAppointmentId),
      ),
  );
};
